module.exports = __webpack_public_path__ + "8c9740a75e8741eaf6c402cbe2c0e971.svg";